export default __webpack_public_path__ + "static/media/Bluenet Nodes.de66784b.jpg";